import { combineReducers } from 'redux';
import tasks, { getTasks } from 'app/reducers/ncd/transaction/tasks';
import details, {
    getNcd,
    updateNcd,
    updateNcdState,
    editDealName,
    uploadLegalDocuments,
    destroyLegalDocuments,
    removeLegalPlaceholder,
    addAdhocDocument,
    updateAdhocDocument,
    isAdhocLoading,
    isAdhocUpdating,
    generateExecDocs,
    pollNCDExecDocs,
    getNCDExecDocs,
    revokeExecDocs,
    updateActors,
    generateDocuments,
    isNCDLoading,
    addAttachment,
    deleteAttachment,
    updateNcdStatus,
} from './transaction';
import bids, { getBidsInfo, updateBid, finalizeBids } from './bids';

const ncd = (state = {}, action) => {
    if (action.id === undefined) return state;
    return {
        [action.id]: combineReducers({
            details,
            bids,
            tasks,
        })(state[action.id], action),
    };
};

export default ncd;

export const action = {
    getNcd,
    getBidsInfo,
    updateNcd,
    updateNcdState,
    updateNcdStatus,
    uploadLegalDocuments,
    updateBid,
    finalizeBids,
    destroyLegalDocuments,
    getTasks,
    editDealName,
    generateExecDocs,
    pollNCDExecDocs,
    getNCDExecDocs,
    revokeExecDocs,
    addAdhocDocument,
    updateAdhocDocument,
    removeLegalPlaceholder,
    isAdhocLoading,
    isAdhocUpdating,
    updateActors,
    generateDocuments,
    isNCDLoading,
    addAttachment,
    deleteAttachment,
};
